import { usePaymentStore, type DialogType } from "@/client/stores/payment";

type UpgradeErrorPayload = {
  upgradeRequired?: boolean;
  feature?: string;
  message?: string;
  currentUsage?: number;
  current?: number; // alias safety
  limit?: number | null;
  tier?: string;
  availablePacks?: Array<any>;
};

const featureToDialogType: Record<string, DialogType> = {
  resume_creation: "RESUME_CREATION",
  resume_pdf_downloads: "PDF_DOWNLOAD",
  ai_resume_tailoring: "AI_TAILORING",
  ats_scoring: "ATS_SCORING",
  resume_parsing: "RESUME_PARSING",
  ai_interview_practice: "INTERVIEW_PRACTICE",
  spotlight_intro_videos: "SPOTLIGHT_INTRO",
};

const featureNames: Record<string, string> = {
  resume_creation: "Resume Creation",
  resume_pdf_downloads: "PDF Downloads",
  ai_resume_tailoring: "AI Resume Tailoring",
  ats_scoring: "ATS Scoring",
  resume_parsing: "Resume Parsing",
  ai_interview_practice: "Interview Practice",
  spotlight_intro_videos: "Spotlight Intro Videos",
};

export function showUpgradeModalFromErrorPayload(payload: UpgradeErrorPayload) {
  if (!payload?.upgradeRequired) return;

  const featureKey = payload.feature ?? "";
  const dialogType = featureToDialogType[featureKey] ?? "CREATE";

  const state = usePaymentStore.getState();

  // Avoid spamming if already open
  if (state.showPaymentDialog) return;

  state.updatePaymentDialog(true, dialogType, {
    featureKey,
    featureName: featureNames[featureKey] ?? payload.feature ?? "Feature",
    currentUsage: payload.currentUsage ?? (payload as any)?.current ?? undefined,
    limit: payload.limit ?? undefined,
    tier: payload.tier ?? undefined,
    availablePacks: payload.availablePacks ?? [],
    redirectTo: typeof window !== "undefined" ? window.location.pathname : undefined,
  });
}
